<template>
    <section class="registration-form">
        <div class="row registration-form__steps">
            <div :class="{'completed': (step > 1) , 'text-danger': step===1}" class="col text-center registration-form__steps__item">
                {{'STEP' | trans}} 1
                <div class="registration-form__steps__line"></div>
            </div>
            <div :class="{'completed': (step > 2 ), 'text-danger': step===2}" class="col text-center registration-form__steps__item">
                {{'STEP' | trans}} 2
                <div class="registration-form__steps__line"></div>
            </div>
            <div :class="{'completed': (step > 3), 'text-danger': step===3}" class="col text-center registration-form__steps__item">
                {{'STEP' | trans}} 3
                <div class="registration-form__steps__line"></div>
            </div>
            <div :class="{'completed': (step > 4) , 'text-danger': step===4}" class="col text-center registration-form__steps__item">
                {{'STEP' | trans}} 4
                <div class="registration-form__steps__line"></div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div v-show="step===1" class="col-md-10 register-step">
                <div class="row mb-5 pb-3">
                    <div class="col text-center">
                        <h2 class="text-uppercase">{{'REGISTER' | trans}}</h2>
                        <span class="font-weight-light">
                            {{'This information must appear to your official identity document' | trans}}
                        </span>
                    </div>
                </div>
                <div class="row form-group mb-3">
                    <div class="col-12 col-md-4 form__item">
                        <label class="form__label" for="FirstName">{{'First Name' | trans}}
	                        <span class="text-danger">*</span>
                        </label>
                        <form-errors :field-name="'user.FirstName'" />
                        <input v-model="user.FirstName" type="text" class="form-control" id="FirstName"
                               :class="status($v.user.FirstName)" placeholder="John">  <!--add to translate-->
	                    <ul class="firstName__messages invalid-feedback list-unstyled" v-if="$v.user.FirstName.$error">
		                    <li v-if="!$v.user.FirstName.required">
			                    {{'First Name field is required' | trans}}
		                    </li>
	                    </ul>
                    </div>
                    <div class="col-12 col-md-4 form__item">
                        <label  class="form__label" for="MiddleName">{{'Middle Name' | trans}}</label>
                        <form-errors :field-name="'user.MiddleName'" />
                        <input v-model="user.MiddleName" type="text" class="form-control" id="MiddleName"
                               placeholder="Alan">
                    </div>
                    <div class="col-12 col-md-4 form__item">
                        <label class="form__label"  for="LastName">{{'Last Name' | trans}}
	                        <span class="text-danger">*</span>
                        </label>
                        <form-errors :field-name="'user.LastName'" />
                        <input v-model="user.LastName" type="text" class="form-control" id="LastName"
                               :class="status($v.user.LastName)" placeholder="Doe">  <!--add to translate-->
	                    <ul class="lastName__messages invalid-feedback list-unstyled" v-if="$v.user.LastName.$error">
		                    <li v-if="!$v.user.LastName.required">
			                    {{'Last Name field is required' | trans}}
		                    </li>
	                    </ul>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-12 col-md-8 form__item">
                        <label for="C_Country_ID" class="form__label">{{'Country' | trans}}
	                        <span class="text-danger">*</span></label>
                        <form-errors :field-name="'user.C_Country_ID'" />
                        <select @change="getCountryPhoneLength" v-model="user.C_Country_ID" id="C_Country_ID" name="C_Country_ID" class="form-control"
                                :class="status($v.user.C_Country_ID)">
                            <option value="">-- {{'Country' | trans}} --</option>
                            <option v-for="(c, index) in service_countries" :value="c.C_Country_ID">{{c.Name}}</option>
                        </select>
	                    <ul class="country__messages invalid-feedback list-unstyled" v-if="$v.user.C_Country_ID.$error">
		                    <li v-if="!$v.user.C_Country_ID.required">
			                    {{'Country field is required' | trans}}
		                    </li>
	                    </ul>
                    </div>
                    <div class="col-12 col-md-4 form__item">
                        <label for="Birthday" class="form__label">{{'Date of Birth' | trans}}</label>
                        <form-errors :field-name="'user.Birthday'" />
                        <datepicker :format="'MM/dd/yyyy'" input-class="form-control" id="Birthday"
                                    className="form-control"  placeholder="MM/DD/YYYY" v-model="user.BirthdayDate">
                        </datepicker>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-12 col-md-6 form__item">
                        <label for="EMail" class="form__label">{{'E-mail'| trans}}
	                        <span class="text-danger">*</span>
                        </label>
                        <form-errors :field-name="'user.EMail'" />
                        <input v-model="user.EMail" id="EMail" type="text" class="form-control" name="EMail"
                               :class="status($v.user.EMail)" placeholder="john@doe.com">
                        <ul class="email__messages invalid-feedback list-unstyled" v-if="$v.user.EMail.$error">
	                        <li v-if="!$v.user.EMail.required">
		                        {{'This field is required' | trans}}
	                        </li>
	                        <li v-if="!$v.user.EMail.email">
                                {{'Email should be valid' | trans}}
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-md-6 form__item">
                        <label for="Phone" class="form__label">{{'Phone' | trans}}<span class="text-danger">*</span></label>
                        <form-errors :field-name="'user.Phone'" />
                        <input v-model="user.Phone" id="Phone" type="text" class="form-control" name="Phone"
                               :class="status($v.user.Phone)" :placeholder="phone_placeholder" :maxlength="phone_length">
	                    <ul class="phone__messages invalid-feedback list-unstyled" v-if="$v.user.Phone.$error">
                            <li v-if="!$v.user.Phone.error">
                                {{'Phone should' | trans}}
                                <span v-if="!$v.user.Phone.required">
                                    {{'be required' | trans}}
                                </span>
                                <span v-if="!$v.user.Phone.numeric">
                                    {{'contain only digits' | trans}}
                                </span>
                                <span v-if="!$v.user.Phone.mustBeginsWithTwoZero">
                                    {{'start with "00"' | trans}}
                                </span>
                                <span v-if="!$v.user.Phone.minLength">
                                    {{'be' | trans}} {{phone_length}} {{'symbols long' | trans}}
                                </span>
                            </li>
	                    </ul>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-12 col-md-6 form__item">
                        <label for="Profession" class="form__label">{{'Profession'| trans}}</label>
                        <form-errors :field-name="'user.Profession'" />
                        <input v-model="user.Profession" id="Profession" type="text" class="form-control" name="Profession" placeholder="manager">
                    </div>
                    <div class="col-12 col-md-6 form__item">
                        <label for="Phone2" class="form__label">{{'Phone' | trans}} 2</label>
                        <form-errors :field-name="'user.Phone2'" />
                        <input v-model="user.Phone2" id="Phone2" type="text" class="form-control" name="Phone2"
                               :class="status($v.user.Phone2)" :placeholder="phone_placeholder" :maxlength="phone_length" >
                        <ul class="phone2__messages invalid-feedback list-unstyled" v-if="$v.user.Phone2.$error">
                            <li v-if="!$v.user.Phone2.error">
                            {{'Phone should' | trans}}
                            <span v-if="!$v.user.Phone2.numeric">
                                {{'contain only digits' | trans}}
                            </span>
                            <span v-if="!$v.user.Phone2.mustBeginsWithTwoZero">
                                {{'start with "00"' | trans}}
                            </span>
                            <span v-if="!$v.user.Phone2.minLength">
                                {{'be 13 symbols long' | trans}}
                            </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-show="step===2" class="register-step col-md-10">
                <div class="row mb-5 pb-3">
                    <div class="col text-center">
                        <h2 class="text-uppercase">{{'Enter Your Address' | trans}}</h2>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-12 col-md-4 form__item">
                        <label for="C_Country_Address_ID" class="form__label">{{'COUNTRY' | trans}}
	                        <span class="text-danger">*</span>
                        </label>
                        <form-errors :field-name="'address.C_Country_Address_ID'" />
                        <select @change="getRegions(address.C_Country_Address_ID)" v-model="address.C_Country_Address_ID"
                                id="C_Country_Address_ID" name="C_Country_Address_ID"
                                class="form-control" :class="status($v.address.C_Country_Address_ID)">
                            <option value="">-- {{'Country' | trans}} --</option>
                            <option v-for="(c, index) in all_countries" :value="c.C_Country_ID">{{c.Name}}</option>
                        </select>
	                    <ul class="country__messages invalid-feedback list-unstyled" v-if="$v.address.C_Country_Address_ID.$error">
		                    <li v-if="!$v.address.C_Country_Address_ID.required">
			                    {{'This field is required' | trans}}
		                    </li>
	                    </ul>
                    </div>
                    <div class="col-12 col-md-4 form__item">
                        <label for="C_Region_ID" class="form__label">{{'REGION' | trans}}</label>
                        <form-errors :field-name="'address.C_Region_ID'" />
                        <select-group v-model="address.C_Region_ID" :list="regions" :fieldValue="'C_Region_ID'" :fieldText="'Name'" :isPending="regionIsPending" id="C_Region_ID" name="C_Region_ID" className="CLASSNAMEEDFEWFW">
                            <option selected value="">-- {{'Region' | trans}} --</option>
                        </select-group>
                    </div>
                    <div class="col-12 col-md-4 form__item">
                        <label for="City" class="form__label">{{'City' | trans}}
	                        <span class="text-danger">*</span>
                        </label>
                        <form-errors :field-name="'address.City'" />
                        <input id="City" v-model="address.City" type="text" class="form-control" name="City_Address"
                               placeholder="New York" :class="status($v.address.City)">
	                    <ul class="country__messages invalid-feedback list-unstyled" v-if="$v.address.City.$error">
		                    <li v-if="!$v.address.City.required">
			                    {{'This field is required' | trans}}
		                    </li>
	                    </ul>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-12 col-md-4 form__item">
                        <label for="Street" class="form__label">{{'Street' | trans}}</label>
                        <form-errors :field-name="'address.Street'" />
                        <input id="Street" v-model="address.Street" type="text" class="form-control" name="Street_Address"  placeholder="Str.">
                    </div>
                    <div class="col-12 col-md-4 form__item">
                        <label for="BuildingNo" class="form__label">{{'Building' | trans}}</label>
                        <form-errors :field-name="'address.BuildingNo'" />
                        <input id="BuildingNo" v-model="address.BuildingNo" type="number" min="0" class="form-control" name="BuildingN_Address"  placeholder="#">
                    </div>
                    <div class="col-12 col-md-4 form__item">
                        <label for="Apartment" class="form__label">{{'Apartment' | trans}}</label>
                        <form-errors :field-name="'address.Apartment'" />
                        <input id="Apartment" v-model="address.Apartment" type="number" min="0" class="form-control" name="Apartment_Address"  placeholder="#">
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-12 col-md-8 form__item">
                        <label for="Address4" class="form__label">{{'Address' | trans}}</label>
                        <form-errors :field-name="'address.Address4'" />
                        <input id="Address4" v-model="address.Address4" type="text" class="form-control" name="Address_Address"  placeholder="Address">
                    </div>
                    <div class="col-12 col-md-4 form__item">
                        <label for="ZIP_Address" class="form__label">{{'ZIP' | trans}}</label>
                        <form-errors :field-name="'address.ZIP'" />
                        <input id="ZIP_Address" v-model="address.ZIP" type="text" class="form-control" name="ZIP_Address" placeholder="12345" maxlength="6">
                    </div>
                </div>
            </div>
            <div v-show="step===3" class="register-step col-md-10">
                <div class="row mb-5 pb-3">
                    <div class="col text-center">
                        <h2 class="text-uppercase">{{'Additional Information' | trans}}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-check form-check-inline form__item mr-5">
                            <span class="form__label form-check-label">{{'GENDER' | trans}}</span>
                            <form-errors :field-name="'user.Gender'" />
                        </div>
                        <div class="form-check-inline default-radio">
                            <input v-model="user.Gender" value="M" type="radio" id="Male" class="form-check-input">
                            <label for="Male">
                                <span></span>
                                {{'Male' | trans}}
                            </label>
                        </div>
                        <div class="form-check-inline default-radio">
                            <input v-model="user.Gender" value="F" type="radio" id="Female" class="form-check-input">
                            <label for="Female">
                                <span></span>
                                {{'Female' | trans}}
                            </label>
                        </div>
                    </div>
                </div>
                <br>
                <div class="row form-group">
                    <div class="col-12 col-md-4 form__item">
                        <label for="Description" class="form__label">{{'DOCUMENT DESCRIPTION' | trans}}</label>
                        <form-errors :field-name="'user.Description'" />
                        <input id="Description" v-model="user.Description" type="text" class="form-control" name="user[Description]"  placeholder="">
                    </div>
                    <div class="col-12 col-md-4 form__item">
                        <label for="ID_C_Country_ID" class="form__label">{{'ID COUNTRY' | trans}}</label>
                        <form-errors :field-name="'user.ID_C_Country_ID'" />
                        <select v-model="user.ID_C_Country_ID" id="ID_C_Country_ID" name="ID_C_Country_ID" class="form-control">
                            <option value="">-- {{'Country' | trans}} --</option>
                            <option v-for="(c, index) in all_countries" :value="c.C_Country_ID">{{c.Name}}</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-4 form__item">
                        <label for="Nationality_ID" class="form__label">{{'NATIONALITY' | trans}}</label>
                        <form-errors :field-name="'user.Nationality_ID'" />
                        <select v-model="user.Nationality_ID" id="Nationality_ID" name="Nationality_ID" class="form-control">
                            <option value="">-- {{'Country' | trans}} --</option>
                            <option v-for="(c, index) in all_countries" :value="c.C_Country_ID">{{c.Name}}</option>
                        </select>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-12 col-md-4 form__item">
                        <label for="IdentityDocType" class="form__label">{{'IDENTITY DOC TYPE' | trans}}</label>
                        <form-errors :field-name="'user.IdentityDocType'" />
                        <select v-model="user.IdentityDocType" id="IdentityDocType" name="IdentityDocType" class="form-control">
                            <option value="">-- {{'Identity Doc Type' | trans}} --</option>
                            <option v-for="(d, index) in doctypes" :value="d.IdentityDocType">{{d.Name}}</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-4 form__item">
                        <label for="DocumentNumber" class="form__label">{{'IDENTITY DOC NUMBER' | trans}}</label>
                        <form-errors :field-name="'user.DocumentNumber'" />
                        <input id="DocumentNumber" v-model="user.DocumentNumber" type="text" class="form-control" name="user[DocumentNumber]"  placeholder="">
                    </div>
                    <div class="col-12 col-md-4 form__item">
                        <label for="IssueDate" class="form__label">{{'ISSUE DATE' | trans}}</label>
                        <form-errors :field-name="'user.IssueDate'" />
                        <datepicker :format="'MM/dd/yyyy'" input-class="form-control" id="IssueDate" className="form-control"  placeholder="MM/DD/YYYY" v-model="user.IssueDateDate"></datepicker>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-12 col-md-4 form__item">
                        <label for="ExpiryDate" class="form__label">{{'EXPIRATION DATE' | trans}}</label>
                        <form-errors :field-name="'user.ExpiryDate'" />
                        <datepicker :format="'MM/dd/yyyy'" input-class="form-control" id="ExpiryDate" className="form-control"  placeholder="MM/DD/YYYY" v-model="user.ExpiryDateDate"></datepicker>
                    </div>
                    <div class="col-12 col-md-8 form__item">
                        <label for="RegionName" class="form__label">{{'REGION NAME' | trans}}</label>
                        <form-errors :field-name="'user.RegionName'" />
                        <input id="RegionName" v-model="user.RegionName" type="text" class="form-control" name="user[RegionName]"  placeholder="">
                    </div>
                </div>
            </div>
            <div v-show="step===4" class="register-step col-md-10">
                <div class="row mb-5 pb-3">
                    <div class="col text-center">
                        <h2 class="text-uppercase">{{'We will ask you this question if you need to reset your password' | trans}}</h2>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-12 col-md-6 form__item">
                        <label for="SecurityQuestion" class="form__label">{{'SECURITY QUESTION' | trans}}</label>
                        <form-errors :field-name="'user.SecurityQuestion'" />
                        <input id="SecurityQuestion" v-model="user.SecurityQuestion" type="text" class="form-control" name="user[SecurityQuestion]"  placeholder="">
                    </div>
                    <div class="col-12 col-md-6 form__item">
                        <label for="Answer" class="form__label">{{'ANSWER' | trans}}</label>
                        <form-errors :field-name="'user.Answer'" />
                        <input id="Answer" v-model="user.Answer" type="text" class="form-control" name="user[Answer]"  placeholder="">
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-12 col-md-6 form__item">
                        <div class="checkbox default-checkbox">
                            <form-errors :field-name="'terms_and_condition'" />
                            <input class="form-check-input" type="checkbox" v-model="terms_and_condition" name="terms_and_condition" id="terms_and_condition">
                            <label class="form-check-label text-danger" for="terms_and_condition">
                                <span></span>
                                {{'I have read and accepted terms of service' | trans}}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <spinner-button :className="'btn btn-danger'" @click="sendForm" :is-pending="isPending">
                            {{'REGISTER' | trans}}
                        </spinner-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-10 pb-3">
                <hr>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-10">
                <div class="row">
                    <div class="col-12 col-sm-4 text-sm-left text-center mb-3 mb-sm-0">
                        <button
                                :disabled="step < 2"
                                :class="{'btn-outline-danger': step > 1, disabled: step < 2, 'btn-secondary text-white': step < 2}"
                                @click.prevent="back" class="btn">
                            <i class="fas fa-long-arrow-alt-left"></i>
                            <span class="pl-3">{{'PREVIOUS' | trans}}</span>
                        </button>
                    </div>
                    <div class="col-12 text-center col-sm-4 mb-3 mb-sm-0" v-show="step < 4">
                        <spinner-button :className="'btn btn-dark-blue'" @click="sendForm" :is-pending="isPending">
                            {{'COMPLETE' | trans}}
                        </spinner-button>
                    </div>
                    <div class="col-12 col-sm-4 text-sm-right text-center">
                        <button
                                v-show="step < 4"
                                @click.prevent="next" class="btn btn-danger">
                            <span class="pr-3">{{'NEXT' | trans}}</span>
                            <i class="fas fa-long-arrow-alt-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
	import  { required, numeric, email, minLength, helpers } from 'vuelidate/lib/validators';
    const mustBeginsWithTwoZero = (value) => {
        if (typeof value === 'undefined' || value === null || value === '') {
            return true
        }
        return /^00.*$/.test(value)
    }
    import { validationMixin } from 'vuelidate';
    export default {
	    mixins: [validationMixin],
        props: ['service_countries', 'all_countries', 'doctypes', 'route', 'routeLogin'],
        data() {
            return {
                isPending: false,
                regionIsPending: false,
                step: 1,
                visitedStep: {'step_1': false, 'step_2': false, 'step_3': false, 'step_4': false,},
                regions: [],
                terms_and_condition: false,
                user: {
                    C_Country_ID: '',
                    ID_C_Country_ID: '',
                    Nationality_ID: '',
                    IdentityDocType: '',
                    Phone: '',
                    Phone2: '',
                },
                address: {
                    C_Country_Address_ID: '',
                    C_Region_ID: '',
                    City: '',
                    Street: '',
	                BuildingNo: '',
	                Apartment: '',
	                Address4: '',
	                ZIP: '',
                },
                phone_length: 13,
                phone_placeholder: '0012345678901',
            }
        },
        methods: {
            getCountryPhoneLength(){
                if (this.user.C_Country_ID){
                    switch(this.user.C_Country_ID){
                        //@todo: change getting country id from somewhere else. use not hardcoded version for validation
                        case ('198')://GUINÉE
                        case ('297')://SÉNÉGAL
                            this.phone_length = 14;
                            this.phone_placeholder = '00123456789012';
                            break;
                        case ('109')://CANADA
                        case ('162')://COTE D'IVOIRE
                        case ('102')://FRANCE
                        case ('208')://India
                        case ('240')://MALI
                        case ('100')://USA
                        default:
                            this.phone_length = 13;
                            this.phone_placeholder = '0012345678901';
                            break;
                    }
                }
            },
            next() {
            	if(this.step == 1) {
		            this.$v.$touch();
	            }
	            if (!this.$v.$invalid) {
		            if (this.step < 4) {
                        this.visitedStep['step_' + this.step] = true;
			            this.step += 1;
		            }
	            }
            },
            back() {
                if (this.step > 1) {
                    this.visitedStep['step_' + this.step] = true;
                    this.step -= 1;
                }
            },
            async getRegions(countryId) {
                this.regions = [];
                this.regionIsPending = true;
                this.address.C_Region_ID = '';
                let result = await axios.get(`/countries/${countryId}/regions`)
                    .finally(() => this.regionIsPending = false);
                this.regions = result.data;
            },
            async sendForm() {
	            this.$v.$touch();
	            if (!this.$v.$invalid) {
		            this.isPending = true;
		            this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
		            await axios.post(this.route, {
			            address: this.address,
			            user: this.user,
			            terms_and_condition: +this.terms_and_condition,
		            })
			            .then(() => {
                            this.EventBus.$emit('event-success', Lang.get('Success'));
				            setTimeout(() => window.location.href = this.routeLogin, 3000)
			            })
			            .finally(() => {
				            this.isPending = false;
			            })
			            .catch(() => {
				            /**
				             * Switch corresponding step due to error
				             */
				            const $steps = jQuery('.register-step');
				            let $step = jQuery('.form-errors-message').eq(0).parents('.register-step');
				            let index = $steps.index($step);
				            this.step = index + 1;
			            });
	            }
            }
        },
        watch: {
            'user.ExpiryDateDate': function () {this.user.ExpiryDate = moment(this.user.ExpiryDateDate).format('MM/DD/YYYY')},
            'user.IssueDateDate': function () {this.user.IssueDate = moment(this.user.IssueDateDate).format('MM/DD/YYYY')},
            'user.BirthdayDate':function () {this.user.Birthday = moment(this.user.BirthdayDate).format('MM/DD/YYYY')},
        },
	    validations() {
            // make Phone value shorter shorter.
            this.user.Phone = this.user.Phone.substr(0, this.phone_length);
            this.user.Phone2 = this.user.Phone2.substr(0, this.phone_length);
		    let v = {
                //@todo: server validation says: "Country of Receiver has more than one HQ or doesn't have it at all."
			    user: {
				    FirstName: {
					    required: required
				    },
				    LastName: {
					    required
				    },
                    EMail: {
	                    required,
                        email
                    },
				    Phone: {
					    required,
                        minLength: minLength(this.phone_length),
                        numeric,
                        mustBeginsWithTwoZero
				    },
                    Phone2: {
                        minLength: minLength(this.phone_length),
                        numeric,
                        mustBeginsWithTwoZero
                    },
				    C_Country_ID: {
					    required
				    }
			    },
			    address: {
				    C_Country_Address_ID: {},
				    City: {}
                }
		    };

		    if(this.step > 1) {
			    v.address.C_Country_Address_ID = { required };
			    v.address.City = { required }
		    }

		    return v;
	    }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/register.vue